import iconLA from 'assets/images/Lao.svg.png'
import iconVi from 'assets/images/Vietnam.svg.png'
import avaDefault from 'assets/images/ava-default.jpeg'
import avaFrame from 'assets/images/ava-frame.svg'
import coin from 'assets/images/coin.svg'
import iconEN from 'assets/images/eng.png'
import logo from 'assets/images/logo.svg'
import {
	HeaderAccountGifthistSVG,
	HeaderAccountLogoutSVG,
	HeaderAccountMyaccountSVG,
	HeaderAccountSettingSVG,
	HeaderHomeSVG,
	HeaderLoginSVG,
	HeaderPrizeSVG,
	HeaderRankSVG,
	HeaderShopSVG,
} from 'assets/svg/HeaderSVG'
import axios from 'axios'
import ConfirmModal from 'components/Modal/ConfirmModal'
import LoginWebModal from 'components/Modal/LoginWebModal'
import { API_PATHS, PATHS } from 'config/routes'
import { localeAtom } from 'config/store'
import { useCheckSub } from 'dataLayer/game'
import {
	getUserQuery,
	queryKeyUserInfo,
	useLogin,
	useUpdateSetting,
} from 'dataLayer/user'
import i18n from 'i18n'
import { useAtom } from 'jotai'
import { useContext, useEffect, useState } from 'react'
import {
	Button,
	Container,
	Dropdown,
	Nav,
	Navbar,
	NavDropdown,
	Row,
} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useQuery, useQueryClient } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom'
import { reloadHeader, setProfilePage } from 'store/actions'
import { curState } from 'store/selector'
import { destroyUser, getLanguage, getUserinfo, removeModal } from 'utils/localStorage'
import { SocketContext } from 'utils/socket'

function Header() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const userInfo = getUserinfo()
	const [modalCancel, setModalCancel] = useState(false)
	const DOMAIN_UID = process.env.REACT_APP_DOMAIN_UID
	const CLIENTID = process.env.REACT_APP_CLIENTID
	const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI
	const queryClient = useQueryClient()
	const location = useLocation()
	const { socket, setSocketRoomId } = useContext(SocketContext)
	const { data: user } = useQuery(getUserQuery())
	const [dataUser, setdataUser] = useState(user)
	const [locale, setLocale] = useAtom(localeAtom)
	const language = getLanguage()
	const [modalConfirm, setModalConfirm] = useState(false)
	const isLoginType = process.env.REACT_APP_IS_LOGIN;

	const changeLanguage = lng => {
		i18n.changeLanguage(lng)
		mutate({
			language: lng,
		})
	}

	const { mutate } = useUpdateSetting(() => { })

	const { mutate: fnLogin, isLoading } = useLogin(
		data => {
			axios.get(API_PATHS.getUser).then(res => {
				const laguageUser = res?.data.data.language
				if (laguageUser) {
					i18n.changeLanguage(laguageUser)
				} else {
					i18n.changeLanguage('la')
				}
			})
			dispatch(reloadHeader(new Date() * 1 + 1))
			navigate(PATHS.HOME_PAGE)
		},
		() => { },
	)

	const selector = useSelector(curState)
	useEffect(() => {
		const fetchData = async () => {
			const { data } = await axios.get(API_PATHS.getUser)
			if (data.data) {
				setdataUser(data.data)
			}
		}
		console.log('run')

		fetchData()
	}, [selector.reloadHeader])

	useEffect(() => {
		setdataUser(user)
	}, [user])

	// const [, setProfileActiveTab] = useAtom(profileActiveTabAtom)

	const [modalShowLoginPass, setModalShowLoginPass] = useState(false)

	function openLoginModal() {
		if (isLoginType === "POPUP") {
			setModalShowLoginPass(true);
		} else if (isLoginType === "LINK") {
			window.location.href = `${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`
		}
	}

	function openConfirmModal() {
		setModalConfirm(true)
	}
	function closeConfirmModal() {
		setModalConfirm(false)
	}

	function handleLogout() {
		destroyUser()
		removeModal()
		closeConfirmModal()
		queryClient.invalidateQueries(queryKeyUserInfo)
		navigate(PATHS.HOME_PAGE)
	}

	function detectUserBeforeNavigate(e) {
		if (!user) {
			e.preventDefault()
			openLoginModal()
		}
	}

	useEffect(() => {
		if (
			window.location.pathname.indexOf(
				PATHS.PLAYROOM_PAGE.replace(':roomId/:gameId', ''),
			) === -1
		)
			setSocketRoomId(0)
	}, [user])

	useEffect(() => {
		if (!user) {
			const url = location.search
			if (location.search.includes('authorization_code=')) {
				let queryString = window.location.search
				const urlParams = new URLSearchParams(queryString)
				const code = urlParams.get('authorization_code')
				console.log(
					'authorization_code:::::',
					urlParams.get('authorization_code'),
				)
				fnLogin({
					grant_type: 'login_with_unitel',
					code: code,
					location: 'ARABICA',
				})
			}
			if (url.includes('tokenLaoID')) {
				let queryString = window.location.search
				const urlParams = new URLSearchParams(queryString)
				const token = urlParams.get('tokenLaoID')
				const language = urlParams.get('language') || 'lo'
				// const appCode = urlParams.get('appCode')
				fnLogin({
					grant_type: 'login_with_lao_app',
					token,
					location: 'ARABICA',
				})
				if (language.toLowerCase() === 'lo') {
					i18n.changeLanguage('la')
				} else if (language.toLowerCase() === 'vi') {
					i18n.changeLanguage('vi')
				} else if (language.toLowerCase() === 'en') {
					i18n.changeLanguage('en')
				}
			}
		}
	}, [location.search])

	const { mutate: mutateCheckSub, isLoading: isCheckingSub } = useCheckSub(data => {
		if (data?.responseCode === '200') {
			window.location.href = data?.data?.urlWebView
		}
	})

	const handleYes = () => {
		if (isCheckingSub) return
		mutateCheckSub({ location: 'HOME', from: "" })
	}

	return (
		<>
			<Navbar className="header">
				<Container fluid>
					<Link
						to={PATHS.HOME_PAGE}
						replace
						state={{ previous: location.pathname }}
					>
						<img alt="Logo's website" src={logo} width="153" height="48" />
					</Link>
					<Nav>
						{/* <NavLink
							to={PATHS.HOME_PAGE}
							replace
							state={{ previous: location.pathname }}
						>
							<HeaderHomeSVG width="16" height="16" viewBox="0 0 16 16" />
							{t('header.home')}
						</NavLink>
						<NavLink
							to={
								!userInfo
									? `${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`
									: '/shop'
							}
							onClick={(e) => {
								if (userInfo) {
									e.preventDefault()
									handleYes()
								}
							}}
							replace
							state={{ previous: location.pathname }}
						>
							<HeaderShopSVG width="16" height="16" viewBox="0 0 16 16" />
							{t('header.shop')}
						</NavLink> */}

						{/* <NavLink
							to={PATHS.PRIZE_PAGE}
							replace
							state={{ previous: location.pathname }}
						>
							<HeaderPrizeSVG width="20" height="20" viewBox="0 0 16 16" />
							{t('header.prize')}
						</NavLink>
						<NavLink
							to={PATHS.RANK_PAGE}
							replace
							state={{ previous: location.pathname }}
						>
							<HeaderRankSVG width="16" height="16" viewBox="0 0 16 16" />
							{t('header.rank')}
						</NavLink> */}
						{/* <NavLink
							to={PATHS.FRIEND_PAGE}
							replace
							state={{ previous: location.pathname }}
							onClick={detectUserBeforeNavigate}
						>
							<HeaderFriendSVG width="16" height="16" viewBox="0 0 16 16" />
							{t('header.friend')}
						</NavLink> */}
						{/* <NavLink to={PATHS.MORE_PAGE}>
							<HeaderMoreSVG width="16" height="16" viewBox="0 0 16 16" />
							{t('header.more')}
						</NavLink> */}
					</Nav>
					<img
						className="language-flag"
						src={
							language === 'en' ? iconEN : language === 'la' ? iconLA : iconVi
						}
						alt=""
					/>
					<Nav className="language-select">
						<NavDropdown
							title={
								language === 'en'
									? t('profile.setting.en')
									: language === 'la'
										? t('profile.setting.la')
										: t('profile.setting.vi')
							}
							id="basic-nav-dropdown"
							align="end"
						>
							{language === 'en' ? (
								<>
									<NavDropdown.Item
										onClick={() => {
											changeLanguage('la')
											setLocale('la')
										}}
										className="dropdown-item"
									>
										<img src={iconLA} alt="" />
										<span>{t('profile.setting.la')}</span>
									</NavDropdown.Item>
									<NavDropdown.Item
										onClick={() => {
											changeLanguage('vi')
											setLocale('vi')
										}}
										className="dropdown-item"
									>
										<img src={iconVi} alt="" />
										<span>{t('profile.setting.vi')}</span>
									</NavDropdown.Item>
								</>
							) : language === 'la' ? (
								<>
									<NavDropdown.Item
										onClick={() => {
											changeLanguage('en')
											setLocale('en')
										}}
									>
										<img src={iconEN} alt="" />
										<span>{t('profile.setting.en')}</span>
									</NavDropdown.Item>
									<NavDropdown.Item
										onClick={() => {
											changeLanguage('vi')
											setLocale('vi')
										}}
									>
										<img src={iconVi} alt="" />
										<span>{t('profile.setting.vi')}</span>
									</NavDropdown.Item>
								</>
							) : (
								<>
									<NavDropdown.Item
										onClick={() => {
											changeLanguage('en')
											setLocale('en')
										}}
									>
										<img src={iconEN} alt="" />
										<span>{t('profile.setting.en')}</span>
									</NavDropdown.Item>
									<NavDropdown.Item
										onClick={() => {
											changeLanguage('la')
											setLocale('la')
										}}
									>
										<img src={iconLA} alt="" />
										<span>{t('profile.setting.la')}</span>
									</NavDropdown.Item>
								</>
							)}
						</NavDropdown>
					</Nav>
					{dataUser ? (
						<Row className="profile-header">
							<Link
								to={PATHS.PROFILE_PAGE}
								replace
								state={{ previous: location.pathname }}
								className="profile-header__coin"
								onClick={() => dispatch(setProfilePage(1))}
							>
								<img src={coin} alt="Total coins" />
								<span>{dataUser?.coin}</span>
							</Link>
							<Dropdown align="end">
								<Dropdown.Toggle>
									<img
										src={dataUser?.avatarImage ?? avaDefault}
										alt="User's avatar"
										onError={e => {
											e.target.onerror = null
											e.target.src = avaDefault
										}}
									/>
									<img src={avaFrame} alt="Avatar's frame" />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item onClick={() => dispatch(setProfilePage(1))}>
										<Link
											to={PATHS.PROFILE_PAGE}
											replace
											state={{ previous: location.pathname }}
										>
											<HeaderAccountMyaccountSVG
												width="20"
												height="20"
												viewBox="0 0 19 19"
											/>
											<p>{t('header.account.my_acc')}</p>
										</Link>
									</Dropdown.Item>
									<Dropdown.Item onClick={() => dispatch(setProfilePage(2))}>
										<Link
											to={PATHS.PROFILE_PAGE}
											replace
											state={{ previous: location.pathname }}
										>
											<HeaderAccountGifthistSVG
												width="20"
												height="20"
												viewBox="0 0 19 19"
											/>
											<p>{t('header.account.gift_hist')}</p>
										</Link>
									</Dropdown.Item>
									{/* <Dropdown.Item onClick={() => dispatch(setProfilePage(3))}>
										<Link
											to={PATHS.PROFILE_PAGE}
											replace
											state={{ previous: location.pathname }}
										>
											<HeaderAccountInvitationSVG
												width="20"
												height="20"
												viewBox="0 0 19 19"
											/>
											<p>{t('header.account.invitation')}</p>
										</Link>
									</Dropdown.Item> */}
									{/* <Dropdown.Item onClick={() => dispatch(setProfilePage(4))}>
										<Link
											to={PATHS.PROFILE_PAGE}
											replace
											state={{ previous: location.pathname }}
										>
											<ProfileIntroduceSVG
												width="20"
												height="20"
												viewBox="0 0 25 22"
											/>
											<p>{t('header.account.introduce')}</p>
										</Link>
									</Dropdown.Item> */}
									<Dropdown.Item onClick={() => dispatch(setProfilePage(5))}>
										<Link
											to={PATHS.PROFILE_PAGE}
											replace
											state={{ previous: location.pathname }}
										>
											<HeaderAccountSettingSVG
												width="20"
												height="20"
												viewBox="0 0 19 19"
											/>
											<p>{t('header.account.setting')}</p>
										</Link>
									</Dropdown.Item>
									{/* <Dropdown.Item onClick={() => dispatch(setProfilePage(6))}>
										<Link
											to={PATHS.PROFILE_PAGE}
											replace
											state={{ previous: location.pathname }}
										>
											<ProfileChangepassSVG
												width="20"
												height="20"
												viewBox="0 0 25 25"
											/>
											<p>{t('header.account.change_pass')}</p>
										</Link>
									</Dropdown.Item> */}
									<Button
										variant="dark"
										onClick={openConfirmModal}
										className="justify-content-start"
									>
										<HeaderAccountLogoutSVG
											width="20"
											height="20"
											viewBox="0 0 19 19"
										/>
										<p>{t('header.account.logout')}</p>
									</Button>
								</Dropdown.Menu>
							</Dropdown>
						</Row>
					) : (
						<>
							{/* <Button
								className="login-btn"
								variant="primary"
								onClick={openLoginModal}
							>
								<Link
									style={{ color: 'white' }}
								>
									<div>
										<HeaderLoginSVG width="24" height="24" viewBox="0 0 24 24" />
										{t('login.login')}
									</div>
								</Link>
							</Button> */}
						</>
					)}
				</Container>
			</Navbar >
			<LoginWebModal
				modalShowLoginPass={modalShowLoginPass}
				setModalShowLoginPass={setModalShowLoginPass}
			/>
			{
				modalConfirm && (
					<ConfirmModal
						show={modalConfirm}
						onHide={closeConfirmModal}
						title={t('modal.profile.logout')}
						onLogout={handleLogout}
					/>
				)
			}

		</>
	)
}

export default Header
